import React, { useState } from 'react';
import { 
    Dialog, 
    DialogTitle, 
    DialogContent, 
    DialogActions, 
    Button, 
    Typography, 
    Box, 
    Stack,
    IconButton
} from '@mui/material';
import { QRCodeSVG } from 'qrcode.react';
import CloseIcon from '@mui/icons-material/Close';

const GroceryExportModal = ({ open, onClose, items, title = "SCAN TO EXPORT", themeColor = "#ed8936" }) => {
    
    // Format the list
    const itemsText = items
        .map(item => `- ${item.name}`)
        .join('\n');
    
    // Construct URL for the web proxy page
    // Using production domain as requested to ensure phones can reach it even if kiosk is localhost
    const encodedList = encodeURIComponent(itemsText);
    const encodedTitle = encodeURIComponent(title);
    const encodedColor = encodeURIComponent(themeColor);
    const shareUrl = `https://ryandymock.com/grocery-share?list=${encodedList}&title=${encodedTitle}&color=${encodedColor}`;

    return (
        <Dialog 
            open={open} 
            onClose={onClose}
            PaperProps={{
                sx: { 
                    borderRadius: 4,
                    overflow: 'hidden',
                    bgcolor: '#fff',
                    maxWidth: 'unset' 
                }
            }}
        >
            {/* Header */}
            <Box sx={{ bgcolor: themeColor, p: 3, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <Typography variant="h4" fontWeight="900" color="white" sx={{ textShadow: '0 2px 4px rgba(0,0,0,0.1)' }}>
                    {title.toUpperCase()}
                </Typography>
                <IconButton onClick={onClose} sx={{ color: 'white', bgcolor: 'rgba(255,255,255,0.2)', '&:hover': { bgcolor: 'rgba(255,255,255,0.3)' } }}>
                    <CloseIcon fontSize="large" />
                </IconButton>
            </Box>
            
            <DialogContent sx={{ p: 4, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                 {items.length === 0 ? (
                    <Box sx={{ p: 4, textAlign: 'center' }}>
                        <Typography variant="h5" color="text.secondary">
                            List is empty!
                        </Typography>
                    </Box>
                ) : (
                    <QRCodeSVG 
                        value={shareUrl} 
                        size={350}
                        level={"M"}
                        includeMargin={true}
                    />
                )}
            </DialogContent>
        </Dialog>
    );
};



export default GroceryExportModal;
